module.exports = __webpack_public_path__ + "static/scenario-activity-dashboard.en-dee3b8a1934a27f983818e9124768c7c.png";